import { Router } from '@angular/router';
import { UserService } from '@ml/core/services';
import { UserRole } from '@ml/core/types/enums';
import { MediaObserver } from '@angular/flex-layout';
import { first, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../services/user.service";
import * as i3 from "@angular/flex-layout/core";
var AdminPhoneGuard = /** @class */ (function () {
    function AdminPhoneGuard(router, userService, mediaObserver) {
        this.router = router;
        this.userService = userService;
        this.mediaObserver = mediaObserver;
    }
    /**
     * If the admin in on phone, redirect to tasks page
     */
    AdminPhoneGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        var user = this.userService.user;
        if (user.role !== UserRole.ADMIN) {
            this.router.navigate(['orders']);
            return true;
        }
        return this.mediaObserver.asObservable().pipe(first(), map(function () {
            if (_this.mediaObserver.isActive('lg')) {
                _this.router.navigate(['orders']);
                return true;
            }
            _this.router.navigate(['tasks']);
            return false;
        }));
    };
    AdminPhoneGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AdminPhoneGuard_Factory() { return new AdminPhoneGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.UserService), i0.ɵɵinject(i3.MediaObserver)); }, token: AdminPhoneGuard, providedIn: "root" });
    return AdminPhoneGuard;
}());
export { AdminPhoneGuard };
